import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { TopBanner } from './components/TopBanner';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Contact } from './pages/Contact';
import { HelpfulInfo } from './pages/HelpfulInfo';
import { ScreenPrinting } from './pages/services/ScreenPrinting';
import { Embroidery } from './pages/services/Embroidery';
import { DirectToGarment } from './pages/services/DirectToGarment';
import { DirectToFilm } from './pages/services/DirectToFilm';
import { LaserEmbroidery } from './pages/services/LaserEmbroidery';
import { LaserEtching } from './pages/services/LaserEtching';
import { GraphicDesign } from './pages/services/GraphicDesign';
import { HeatTransfer } from './pages/services/HeatTransfer';
import { PromotionalProducts } from './pages/services/PromotionalProducts';
import { PersonalizedProducts } from './pages/services/PersonalizedProducts';
import { LaserEngraving } from './pages/services/LaserEngraving';
import { Banners } from './pages/services/Banners';
import { BusinessCards } from './pages/services/BusinessCards';
import { YardSigns } from './pages/services/YardSigns';
import { VehicleDecals } from './pages/services/VehicleDecals';
import { VehicleMagnets } from './pages/services/VehicleMagnets';
import { Decals } from './pages/services/Decals';
import { FAQs } from './pages/helpful-info/FAQs';
import { Compliance } from './pages/helpful-info/Compliance';
import { ScreenPrintingAdvice } from './pages/helpful-info/ScreenPrintingAdvice';
import { VectorArt } from './pages/helpful-info/VectorArt';
import { WearHausWay } from './pages/helpful-info/WearHausWay';
import { TermsAndConditions } from './pages/helpful-info/TermsAndConditions';
import { PrivacyPolicy } from './pages/helpful-info/PrivacyPolicy';
import { ProductCatalogs } from './pages/products/ProductCatalogs';
import { CampDesigns } from './pages/products/CampDesigns';
import { MonthlySpecial } from './pages/products/MonthlySpecial';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 flex flex-col" data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <TopBanner data-id="element-2" />
      <Header data-id="element-3" />
      <main className="flex-grow" data-id="element-4">
        <Routes data-id="element-5">
          <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
          <Route path="/about" element={<About data-id="element-9" />} data-id="element-8" />
          <Route path="/services" element={<Services data-id="element-11" />} data-id="element-10" />
          <Route path="/contact" element={<Contact data-id="element-13" />} data-id="element-12" />
          <Route path="/helpful-info" element={<HelpfulInfo data-id="element-15" />} data-id="element-14" />
          <Route path="/services/screen-printing" element={<ScreenPrinting data-id="element-17" />} data-id="element-16" />
          <Route path="/services/embroidery" element={<Embroidery data-id="element-19" />} data-id="element-18" />
          <Route path="/services/direct-to-garment" element={<DirectToGarment data-id="element-21" />} data-id="element-20" />
          <Route path="/services/direct-to-film" element={<DirectToFilm data-id="element-23" />} data-id="element-22" />
          <Route path="/services/laser-embroidery" element={<LaserEmbroidery data-id="element-25" />} data-id="element-24" />
          <Route path="/services/laser-etching" element={<LaserEtching data-id="element-27" />} data-id="element-26" />
          <Route path="/services/graphic-design" element={<GraphicDesign data-id="element-29" />} data-id="element-28" />
          <Route path="/services/heat-transfer" element={<HeatTransfer data-id="element-31" />} data-id="element-30" />
          <Route path="/services/promotional-products" element={<PromotionalProducts data-id="element-33" />} data-id="element-32" />
          <Route path="/services/personalized-products" element={<PersonalizedProducts data-id="element-35" />} data-id="element-34" />
          <Route path="/services/laser-engraving" element={<LaserEngraving data-id="element-37" />} data-id="element-36" />
          <Route path="/services/banners" element={<Banners data-id="element-39" />} data-id="element-38" />
          <Route path="/services/business-cards" element={<BusinessCards data-id="element-41" />} data-id="element-40" />
          <Route path="/services/yard-signs" element={<YardSigns data-id="element-43" />} data-id="element-42" />
          <Route path="/services/vehicle-decals" element={<VehicleDecals data-id="element-45" />} data-id="element-44" />
          <Route path="/services/vehicle-magnets" element={<VehicleMagnets data-id="element-47" />} data-id="element-46" />
          <Route path="/services/decals" element={<Decals data-id="element-49" />} data-id="element-48" />
          <Route path="/helpful-info/faqs" element={<FAQs data-id="element-51" />} data-id="element-50" />
          <Route path="/helpful-info/compliance" element={<Compliance data-id="element-53" />} data-id="element-52" />
          <Route path="/helpful-info/screen-printing-advice" element={<ScreenPrintingAdvice data-id="element-55" />} data-id="element-54" />
          <Route path="/helpful-info/vector-art" element={<VectorArt data-id="element-57" />} data-id="element-56" />
          <Route path="/helpful-info/wear-haus-way" element={<WearHausWay data-id="element-59" />} data-id="element-58" />
          <Route path="/helpful-info/terms-and-conditions" element={<TermsAndConditions data-id="element-61" />} data-id="element-60" />
          <Route path="/helpful-info/privacy-policy" element={<PrivacyPolicy data-id="element-63" />} data-id="element-62" />
          <Route path="/products/catalogs" element={<ProductCatalogs data-id="element-65" />} data-id="element-64" />
          <Route path="/products/camp-designs" element={<CampDesigns data-id="element-67" />} data-id="element-66" />
          <Route path="/products/monthly-special" element={<MonthlySpecial data-id="element-69" />} data-id="element-68" />
        </Routes>
      </main>
      <Footer data-id="element-70" />
    </div>;
}